import { render } from "./sumary.vue?vue&type=template&id=f55b7988&scoped=true"
import script from "./sumary.vue?vue&type=script&lang=js"
export * from "./sumary.vue?vue&type=script&lang=js"

import "./sumary.vue?vue&type=style&index=0&id=f55b7988&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f55b7988"]])

export default __exports__